import { Avatar, Box } from "@mui/material";

export default function UserAvatar({ user, size = 32 }) {
  // Hilfsfunktion für Initialen
  const getInitials = (user) => {
    if (!user) return "";
    const { first_name = "", last_name = "" } = user;
    return `${first_name[0] || ""}${last_name[0] || ""}`.toUpperCase();
  };

  if (!user) {
    return;
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Avatar sx={{ width: size, height: size, fontSize: 16 }}>
        {getInitials(user)}
      </Avatar>
      {user.full_name}
    </Box>
  );
}
